// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.add-to-routine-content {
  padding: 20px;
  flex: 1;
  overflow-y: auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.add-to-routine-tabs {
  margin-bottom: 16px;
  display: flex;
  justify-content: center;
}

.actions-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.action-card {
  border: 1px solid var(--color-gray);
  border-radius: 8px;
  padding: 16px;
  cursor: pointer;
  transition: all 0.2s ease;
  background-color: var(--color-white);
}

.action-card:hover {
  border-color: var(--color-primary-green);
  box-shadow: var(--shadow-sm);
}

.action-card.selected {
  border-color: var(--color-primary-green);
  background-color: var(--color-light-green);
  box-shadow: 0 2px 8px var(--accent-ring);
}



.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px 20px;
}



.products-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}



.add-to-routine-footer {
  display: flex;
  gap: 12px;
  padding: 20px;
  border-top: 1px solid var(--color-light-gray);
  background-color: var(--color-white);
  flex-shrink: 0;
}

.add-to-routine-footer .cancel-button {
  flex: 1;
}

.add-to-routine-footer .add-button {
  flex: 1;
}
`, "",{"version":3,"sources":["webpack://./src/bottomdrawers/AddToRoutineBottomSheet.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,OAAO;EACP,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,wCAAwC;EACxC,4BAA4B;AAC9B;;AAEA;EACE,wCAAwC;EACxC,0CAA0C;EAC1C,wCAAwC;AAC1C;;;;AAIA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;;;AAIA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;;;AAIA;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,6CAA6C;EAC7C,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,OAAO;AACT","sourcesContent":[".add-to-routine-content {\n  padding: 20px;\n  flex: 1;\n  overflow-y: auto;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.add-to-routine-tabs {\n  margin-bottom: 16px;\n  display: flex;\n  justify-content: center;\n}\n\n.actions-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.action-card {\n  border: 1px solid var(--color-gray);\n  border-radius: 8px;\n  padding: 16px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  background-color: var(--color-white);\n}\n\n.action-card:hover {\n  border-color: var(--color-primary-green);\n  box-shadow: var(--shadow-sm);\n}\n\n.action-card.selected {\n  border-color: var(--color-primary-green);\n  background-color: var(--color-light-green);\n  box-shadow: 0 2px 8px var(--accent-ring);\n}\n\n\n\n.loading-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 40px 20px;\n}\n\n\n\n.products-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n\n\n.add-to-routine-footer {\n  display: flex;\n  gap: 12px;\n  padding: 20px;\n  border-top: 1px solid var(--color-light-gray);\n  background-color: var(--color-white);\n  flex-shrink: 0;\n}\n\n.add-to-routine-footer .cancel-button {\n  flex: 1;\n}\n\n.add-to-routine-footer .add-button {\n  flex: 1;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
